import { setSocialMediaPlatformPreset } from "@/store/features/bulkResize/actions";
import { SocialMediaPreset } from "@/store/types/resizeSettings";
import { bulkResizeSelector } from "store/features/bulkResize/selectors/bulkResizeSelector";
import { BulkResizeState } from "store/features/bulkResize/types";
import { useAppSelector, useAppDispatch } from "store/store";

export const useSocialMediaPlatformPreset = () => {
    const {
        resizeSettings: {
            bySocialMedia: {
                platform: { preset },
            },
        },
    } = useAppSelector(bulkResizeSelector, equalityFn);
    const dispatch = useAppDispatch();

    const handleChange = (value: SocialMediaPreset) => dispatch(setSocialMediaPlatformPreset(value));

    return {
        preset,
        handleChange,
    };
};

const equalityFn = (left: BulkResizeState, right: BulkResizeState) => {
    if (
        left.resizeSettings.bySocialMedia.platform.preset.name ===
            right.resizeSettings.bySocialMedia.platform.preset.name &&
        left.resizeSettings.bySocialMedia.platform.preset.dimension ===
            right.resizeSettings.bySocialMedia.platform.preset.dimension
    ) {
        return true;
    }
    return false;
};
